import { render } from "./Base.vue?vue&type=template&id=648b1bff"
const script = {}

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__